<img [src]="getSrc()" [ngStyle]="{'width': width + 'px', 'height': height + 'px'}">
